import script from "./themeTablePush.vue?vue&type=script&lang=ts&setup=true"
export * from "./themeTablePush.vue?vue&type=script&lang=ts&setup=true"

import "./themeTablePush.vue?vue&type=style&index=0&id=170ecad5&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/运营辅助平台正式前端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-170ecad5"]])

export default __exports__